var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2935 14.5921C15.1247 15.6898 14.1802 16.5 13.0697 16.5H3C2.17157 16.5 1.5 15.8284 1.5 15V9.75C1.5 8.92157 2.17157 8.25 3 8.25H4.76259C5.05899 8.25 5.32758 8.07545 5.44795 7.8046L8.08729 1.86609C8.18623 1.64347 8.407 1.5 8.65062 1.5C9.672 1.5 10.5 2.328 10.5 3.34938V6C10.5 6.41421 10.8358 6.75 11.25 6.75H13.8774C15.2564 6.75 16.3109 7.97917 16.1012 9.34213L15.2935 14.5921Z",
    fill: "#DCEBFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 16.5V8.25M1.5 9.75V15C1.5 15.8284 2.17157 16.5 3 16.5H13.0697C14.1802 16.5 15.1247 15.6898 15.2935 14.5921L16.1012 9.34213C16.3109 7.97917 15.2564 6.75 13.8774 6.75H11.25C10.8358 6.75 10.5 6.41421 10.5 6V3.34938C10.5 2.328 9.672 1.5 8.65062 1.5C8.407 1.5 8.18623 1.64347 8.08729 1.86609L5.44795 7.8046C5.32758 8.07545 5.05899 8.25 4.76259 8.25H3C2.17157 8.25 1.5 8.92157 1.5 9.75Z",
    stroke: "#1B4060",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpIcon);
export default __webpack_public_path__ + "static/media/thumbs-up-icon.ce963833.svg";
export { ForwardRef as ReactComponent };